import { message } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import config from "app/envConfig";
import { resetStateAction } from "common/redux/resetStateAction";
import { useChangePasswordMutation } from "features/auth/authAPI";
import { useState } from "react";
import { useDispatch } from "react-redux";

export default function useChangePassword() {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const [changePassword, { isLoading }] = useChangePasswordMutation();
  const { logout } = useAuth0();

  const onFinish = async (values) => {
    const result = await changePassword(values);
    if ("data" in result) {
      dispatch(resetStateAction());
      message.success("Successfully changed password!", 2);

      if (config.useAuth0) {
        logout({
          logoutParams: {
            returnTo: `${window.location.origin}/login`,
          },
        });
      }
    }
    if ("error" in result) {
      setErrorMessage("Failed to change password");
    }
  };

  return {
    onFinish,
    errorMessage,
    isLoading,
  };
}
